import { phoneNumberSanitizer } from '../utilities/sanitizers'

export default class PhoneNumberInputSanitizer {
  constructor () {
    this.data = {
      elementsToWatch: [
        'contacttel',
        'personaltel'
      ]
    }
    this.data.elementsToWatch.forEach((elementId) => {
      const element = document.getElementById(elementId)
      if (!element) {
        return
      }
      element.addEventListener('input', (e) => {
        e.target.value = phoneNumberSanitizer(e.target.value)
      })
    })
  }
}
